import { createSelector } from 'reselect';

export const getVersion = (state) => state.version.data;
